import { render, staticRenderFns } from "./ControleInventario.vue?vue&type=template&id=1e245ca2&scoped=true&"
import script from "./ControleInventario.vue?vue&type=script&lang=js&"
export * from "./ControleInventario.vue?vue&type=script&lang=js&"
import style0 from "./ControleInventario.vue?vue&type=style&index=0&id=1e245ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e245ca2",
  null
  
)

export default component.exports